import React from 'react';
import { Navigate, Routes, Route, useNavigate, useParams } from 'react-router-dom';
import RenaissanceLanding from './components/landing/RenaissanceLanding';
import VedaExplorerNew from './components/VedaExplorerNew';
import { ThemeProvider } from './context/ThemeContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { CANONICAL_ROUTES, LEGACY_REDIRECT_ROUTES } from './routes/routeMap';
import './styles/globals.css';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 2,
    },
  },
});

function LandingScreen() {
  const navigate = useNavigate();

  const handleEnterMandala = (mandalaNumber) => {
    navigate(`${CANONICAL_ROUTES.EXPLORER_BY_MANDALA_BASE}/${mandalaNumber}`);
  };

  return <RenaissanceLanding onEnterMandala={handleEnterMandala} />;
}

function ExplorerScreen() {
  const navigate = useNavigate();
  const { mandalaNumber } = useParams();

  const parsedMandala = mandalaNumber ? Number.parseInt(mandalaNumber, 10) : null;
  const initialMandala = Number.isInteger(parsedMandala) ? parsedMandala : null;

  return (
    <VedaExplorerNew
      initialMandala={initialMandala}
      onBack={() => navigate(CANONICAL_ROUTES.HOME)}
    />
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path={CANONICAL_ROUTES.HOME} element={<LandingScreen />} />
      <Route path={CANONICAL_ROUTES.EXPLORER} element={<ExplorerScreen />} />
      <Route path={CANONICAL_ROUTES.EXPLORER_BY_MANDALA} element={<ExplorerScreen />} />
      {LEGACY_REDIRECT_ROUTES.map((path) => (
        <Route key={path} path={path} element={<Navigate to={CANONICAL_ROUTES.HOME} replace />} />
      ))}
      <Route path="*" element={<Navigate to={CANONICAL_ROUTES.HOME} replace />} />
    </Routes>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AppRoutes />
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
